import { HistorySettings } from 'app/modules/wallforming/components/placement-history/types/historySettings';

import type { TranslationKey } from 'app/modules/wallforming/components/input-binding/types/translationKey';
import type { HistoryDialog } from 'app/modules/wallforming/components/placement-history/types/historyDialog';
import type { HistoryItem } from 'app/modules/wallforming/components/placement-history/types/historyItem';
import type { HistoryTransformDetail } from 'app/modules/wallforming/components/placement-history/types/historyTransformDetail';

export const DEFAULT_HISTORY_SETTINGS: HistorySettings = {
    undoSteps: 100,
    memoryLimitMb: 32,
    repeatSteps: 32
};

export interface HistoryState {
    historySettings: HistorySettings;
    setHistorySettings: (settings: HistorySettings) => void;

    undoHistory: HistoryItem[];
    historyBaseId: number;
    historyPosition: number;
    historyBytes: number;
    repeatHistory: HistoryItem[];
    historyDialog: HistoryDialog | null;

    setHistoryDialog: (dialog: HistoryDialog | null) => void;
    scrollToHistory: (id: number) => boolean;
    repeatLast: () => boolean;
    repeatHistoryItem: (id: number) => boolean;
    setHistoryRepeat: (label: TranslationKey, operation: () => void) => void;
    setHistoryTransformDetail: (detail: HistoryTransformDetail) => void;

    canUndo: boolean;
    canRedo: boolean;
    undoLabel: TranslationKey | null;
    redoLabel: TranslationKey | null;
    isHistoryTransactionActive: boolean;
    beginHistoryTransaction: (label: TranslationKey) => void;
    commitHistoryTransaction: () => void;
    cancelHistoryTransaction: () => void;
    runHistoryTransaction: <T>(label: TranslationKey, operation: () => T) => T;

    /** Synchronous preview-only mutations; accepted document edits must use a transaction. */
    runWithoutHistory: <T>(operation: () => T) => T;
    clearHistory: () => void;
    undo: () => boolean;
    redo: () => boolean;
}
